export default {
  '作业列表':'Assignment List',
  '请选择班级':'Select Class',
  '作业标题、发布人模糊搜索':'Search by title/publisher',
  '发布作业':'Publish Assignment',

  '到':'to',
  '提前结束':'Early Termination',
  '作业标题':'Assignment Title',
  '接收班级':'Receiving Class',
  '发布人':'Publisher',
  '作业周期':'Assignment Period',
  '确认要删除{workName}吗？':'Confirm to delete {workName}?',

  '删除后，无法查看该作业！':'Deleted assignments cannot be viewed!',
  '{workName}删除成功！':'{workName} deleted successfully!',
  '确认要提前结束{workName}吗？':'Confirm to terminate {workName} early?',
  '结束后，用户将不能继续参与作业！':'Users cannot participate after termination!',
  '{workName}提前终止成功！':'{workName} terminated successfully!',

  '编辑作业':'Edit Assignment',
  '查看作业':'View Assignment',
  '作业详情':'Assignment Detail',
  '作业内容':'Assignment Content',
  '详情':'Detail',
  '明细':'Details',
  '数据':'Data',
  '发布作业':'Publish Assignment',
  '填写基本信息':'Fill Basic Info',
  '配置作业内容':'Configure Content',
  '基础信息':'Basic Information',
  '作业名称':'Assignment Name',
  '请输入作业名称':'Enter assignment name',
  '周期':'Cycle',
  '范围':'Scope',
  '请选择周期':'Select cycle',
  '请选择范围':'Select scope',

  '配置运动项目':'Configure Sport Items',
  '每天重复':'Daily Repeat',
  '每周重复':'Weekly Repeat',
  '布置方式':'Assignment Mode',
  '增加项目':'Add Item',
  '选择项目':'Select Item',
  '运动方式':'Exercise Mode',
  '支持特殊项目':'Support Special Items',
  '强度':'Intensity',
  '分':'Minute(s)',
  '至':'to',
  '秒':'Second(s)',
  '组数':'Sets',
  '组':'Set(s)',

  '项目名':'Item Name',
  '运动强度':'Exercise Intensity',
  '周一':'Mon',
  '周二':'Tue',
  '周三':'Wed',
  '周四':'Thu',
  '周五':'Fri',
  '周六':'Sat',
  '周日':'Sun',
  '热身':'Warm-up',
  '核心':'Core',
  '拉伸':'Stretch',

  '请选择布置方式':'Select Assignment Mode',
  '请选择应用终端':'Select Device',
  '项目列表不能为空':'Items cannot be empty',
  '作业保存成功！':'Assignment saved!',
  '编辑项目':'Edit Item',
  '新增项目':'Add Item',
  '请选择运动项目':'Select Sport Item',
  '请填写运动强度':'Enter Exercise Intensity',
  '运动强度填写错误':'Invalid Intensity',
  '确认要删除运动项目【{sportSkuName}】吗？':'Delete sport item 【{sportSkuName}】?',
  '删除成功!':'Deleted!',

  '确认要返回吗？':'Are you sure you want to return?!',
  '返回后，页面数据不做保存':'After returning, the page data is not saved!',

  // Data page related
  '作业班级数据':'Assignment Class Data',
  '日期':'Date',
  '班级概况':'Class Overview',
  '参与率':'Participation Rate',
  '打卡率':'Check-in Rate',
  '达标率':'Standard Rate',
  '班级详情':'Class Detail',
  '打卡情况':'Check-in Status',
  '达标情况':'Standard Status',
  '请输入姓名或学籍号':'Enter name or student ID',
}
